/**
 * BottomDecor
 *
 * 画面下端の装飾。要件:
 *   - 左にスピーカー穴風の白丸6個
 *   - 右にシリアル風「SL-001」緑文字
 *
 * 機能はゼロ。HUDの「これは機械だぞ」感を演出する役割だけ。
 */

import styles from './BottomDecor.module.css';

export function BottomDecor() {
  return (
    <div className={styles.root} aria-hidden>
      <div className={styles.speakers}>
        {Array.from({ length: 6 }, (_, i) => (
          <span key={i} className={styles.dot} />
        ))}
      </div>
      <span className={styles.serial}>SL-001</span>
    </div>
  );
}
